import styles from './style.postcss';

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ViewNavButton from '../ViewNavButton';
import ViewNavExtra from '../ViewNavExtra';
import { testClass } from 'omni-common-ui';

const ViewNavBig = ({ children }) => {
  const childrenArr = React.Children.toArray(children);
  const className = styles.ViewNavBig;
  const extraContent = childrenArr.filter((child) =>
    child.type !== ViewNavButton && child.type !== ViewNavExtra);
  return <div className={className}>
    <div className={classnames(
      styles.ViewNavBig_actions,
      testClass('viewnav-action-buttons')
    )}>
      {extraContent}
      {childrenArr.filter((child) => child.type === ViewNavButton)}
    </div>
    {childrenArr.find((child) => child.type === ViewNavExtra)}
  </div>;
};

ViewNavBig.propTypes = {
  children: PropTypes.node,
};

export default ViewNavBig;



// WEBPACK FOOTER //
// ./containers/Group/CoveredInClassHFv4/ViewNavCIC/ViewNavBig/index.jsx